import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const TermsAndConditionsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-black/20 backdrop-blur-sm flex items-center justify-center" style={{backgroundImage: 'url(/images/Asset5.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundAttachment: 'fixed'}}>
      <div className="w-full max-w-2xl mx-auto px-4 py-4 sm:py-6 md:py-8">
        {/* Language Switcher */}
        <div className="absolute top-4 right-4 z-10">
          <LanguageSwitcher />
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-orange-400 to-orange-500 p-4 sm:p-6 text-center">
            <div className="flex items-center justify-center mb-3">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full border-2 border-white flex items-center justify-center">
                <img 
                  src="/images/Asset2.png" 
                  alt="Temple Logo" 
                  className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
                />
              </div>
            </div>
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-white">
              {t('pages.termsAndConditions.title')}
            </h1>
            <p className="text-white/90 text-xs sm:text-sm mt-1">
              {t('pages.termsAndConditions.subtitle')}
            </p>
          </div>

          {/* Content */}
          <div className="p-4 sm:p-6 md:p-8">
            <div className="prose prose-sm sm:prose-base max-w-none">
              <p className="text-gray-700 mb-4 sm:mb-6 text-sm sm:text-base">
                {t('pages.termsAndConditions.intro')}
              </p>

              <div className="space-y-4 sm:space-y-6">
                {/* Point 1 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    1. {t('pages.termsAndConditions.point1.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point1.content')}
                  </p>
                </div>

                {/* Point 2 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    2. {t('pages.termsAndConditions.point2.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point2.content')}
                  </p>
                </div>

                {/* Point 3 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    3. {t('pages.termsAndConditions.point3.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point3.content')}
                  </p>
                </div>

                {/* Point 4 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    4. {t('pages.termsAndConditions.point4.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point4.content')}
                  </p>
                </div>

                {/* Point 5 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    5. {t('pages.termsAndConditions.point5.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point5.content')}
                  </p>
                </div>

                {/* Point 6 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    6. {t('pages.termsAndConditions.point6.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point6.content')}
                  </p>
                </div>

                {/* Point 7 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    7. {t('pages.termsAndConditions.point7.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point7.content')}
                  </p>
                </div>

                {/* Point 8 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    8. {t('pages.termsAndConditions.point8.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point8.content')}
                  </p>
                </div>

                {/* Point 9 */}
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-2">
                    9. {t('pages.termsAndConditions.point9.title')}
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base">
                    {t('pages.termsAndConditions.point9.content')}
                  </p>
                </div>
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-6 sm:mt-8">
              <button
                onClick={handleBack}
                className="w-full bg-gray-600 hover:bg-gray-700 text-white font-semibold py-2 sm:py-3 px-4 rounded-lg transition-colors text-sm sm:text-base"
              >
                {t('pages.termsAndConditions.back')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;

